export default class {
    constructor ($q, $state, $translate, lodash, FormSubmissionResource, FormSubmissionService,
                 FORMS_DISPLAY_TYPE_ENUM, FORMS_SUBMISSION_STATUS_ENUM, QUESTIONS_TYPE_ENUM) {
        this.$q = $q;
        this.lodash = lodash;
        this.FormSubmissionResource = FormSubmissionResource;
        this.FormSubmissionService = FormSubmissionService;
        this.FORMS_DISPLAY_TYPE_ENUM = FORMS_DISPLAY_TYPE_ENUM;
        this.FORMS_SUBMISSION_STATUS_ENUM = FORMS_SUBMISSION_STATUS_ENUM;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.lang = $translate.use();
        this.fallbackLanguage = $state.params.fallbackLanguage;
    }

    /**
     * Loads submission questions and answers and formats them for use in quiz
     * @param submission
     * @param loadAnswers
     * @returns {*}
     */
    loadQuestions (submission, loadAnswers = false) {
        const defer = this.$q.defer();

        this.getQuestions(submission, loadAnswers)
            .then(questions => {
                if (loadAnswers) {
                    this.FormSubmissionService.getAnswers(submission)
                        .then((answers) => {
                            questions.map((question) => {
                                if (question.type === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX) {
                                    question.submittedAnswers = this.lodash.filter(answers, answer => answer.questionId === question.id);
                                }
                                else {
                                    question.submittedAnswer = this.lodash.find(answers, answer => answer.questionId === question.id);
                                }
                                return question;
                            });

                            defer.resolve(questions);
                        })
                        .catch(error => defer.reject(error));
                }
                else {
                    defer.resolve(questions);
                }
            })
            .catch(error => defer.reject(error));
        return defer.promise;
    }

    getQuestions (submission, loadAnswers) {
        const params = {
            guid: submission.guid,
            sort: 'id',
            expand: submission.isTrial || loadAnswers ? 'activeI18n,questionI18ns,questionAnswers,questionAnswersI18ns,formQuestions' : 'activeI18n,formQuestions',
            _lang: this.lang,
            fallbackLanguage: this.fallbackLanguage,
            pageSize: 0
        };

        // if submission finished and still questions queried, we are in correct answers block which needs all questions
        if (submission.status === this.FORMS_SUBMISSION_STATUS_ENUM.KEYS.FINISHED) {
            params.excludeAnswered = 0;
        }

        if (submission.form.displayType === this.FORMS_DISPLAY_TYPE_ENUM.KEYS.SEPARATE_PAGES) {
            if (submission.finishedQuestionCount === submission.totalQuestionCount) {
                params.excludeAnswered = 0;
            }
            else {
                params.pageSize = submission.form.questionsPerPage;
            }
        }

        return this.FormSubmissionResource.quizQuestions(params).$promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/quiz/question/index.js